__turbopack_context__.v({
  "decoration": "ogKbpG_decoration",
  "noContent": "ogKbpG_noContent",
  "noContentNoUrl": "ogKbpG_noContentNoUrl",
  "selected": "ogKbpG_selected",
});
